export var SessionType;
(function (SessionType) {
    SessionType["CONTINUOUS"] = "CONTINUOUS";
    SessionType["PLAIN"] = "MANUAL";
})(SessionType || (SessionType = {}));
//# sourceMappingURL=session-type.enum.js.map